<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" label-position="top">
      <h3 class="title">基础信息：</h3>
      <el-row class="dialog-form" v-if="info">
        <el-col class="g-basic-info">
          <div class="g-service-type">{{info.vaStatus|vehicleState}}</div>
          <el-row>
            <el-col :span="12"><p>车牌号：{{info.vaVehicleNumber|empty}}</p></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><p>申请提交时间：{{new Date(info.vaCreateTime).format('yyyy-MM-dd hh:mm:ss')}}</p></el-col>
          </el-row>
          <div class="g-col-line"></div>
          <el-row>
            <el-col :span="12"><p>车主姓名：{{info.vaVehicleName|empty}}</p></el-col>
            <el-col :span="12"><p>所属企业：{{info.vaCompanyName|empty}}</p></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><p>租赁有效期：{{info.vaVehicleEndTime|date}}</p></el-col>
            <el-col :span="12"><p>可用停车场：{{info.vaCarParkName|empty}}</p></el-col>
          </el-row>
        </el-col>
      </el-row>
      <h3 class="title" v-show="info.vaStatus !== 1">审批信息：</h3>
      <div class="dialog_form  basic_info" v-show="info.vaStatus !== 1">
        <el-row>
          <el-col :span="24"><p>审批时间：{{info.vaApproveTime|datetime}}</p></el-col>
        </el-row>
        <el-row style="margin: 10px 0;">
          <el-col :span="24"><p>审批意见：{{info.vaRemark|empty}}</p></el-col>
        </el-row>
      </div>
      <div class="text-right" style="margin-top: 20px;">
        <el-button type="success" @click="edit" size="mini" v-if="info.vaStatus==1">编辑</el-button>
        <el-button type="success" @click="edit" size="mini" v-if="info.vaStatus==3">重新发起</el-button>
      </div>
    </el-form>
    <el-dialog title="车位租赁编辑申请" :visible.sync="createInvoiceDialog" top="5%" center width="650px" 
    :modal-append-to-body='false' :append-to-body='true' style="padding: 0;">
      <v-parking-rental-application v-if="createInvoiceDialog" :vaId="vaId" 
                        @closeDialog="createInvoiceDialog=false" @init="init()">
      </v-parking-rental-application>
    </el-dialog>
  </div>
</template>

<script>
  import * as getData from "../service/getData";
  import * as global from "../config/mUtils";

  export default {
    data() {
      return {
        info:{
          vaStatus: ''
        },
        activities:[],
        noteCreateName:'',
        createInvoiceDialog:false,
      };
    },
    created() {
    },
    mounted() {
      this.init();
    },
    props: ['vaId'],
    computed: {},
    methods: {
      edit(){
        this.createInvoiceDialog = true;
      },
      init() {
        getData.getVehicleDetail({vaId:this.vaId}).then(res => {
          if (res.data.code === 1) {
            this.info = res.data.data.vehicleApproveForm;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
      },
      submit(){
        getData.noteSure(this.vaId).then(res => {
          if (res.data.code === 1) {
            this.$message({
              message: '确认成功',
              type: "success"
            });
            this.close(1);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
      },
      openFile (url) {
        window.open(url)
      },
      downLoad(file){
       window.open('/company/download/downloadWorkflowFileUseName?fileName='+file.fileName+'&fileUrl='+file.exportFile)
      },
      close(type) {
        if (type === 1) {
          this.$emit("init");
        }
        this.$emit("closeDialog");
      }
    },
    components: {},
    watch: {}
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-handle-manager{
    padding-left: 20px;
    padding-top: 10px;
    margin-top: 10px;
  }
  .g-executor-box{
    padding-bottom: 10px;
  }
  .dialog-form{
    box-shadow:0px 3px 10px 0px rgba(0,14,26,0.04);
    border-radius:6px;
  }
  .dialog-form{
    box-shadow:0px 3px 10px 0px rgba(0,14,26,0.04);
    border-radius:6px;
  }
</style>
<style lang="scss">
  .g-assign-item{
    .el-form-item__label{
      padding: 0;
    }
  }
  .el-dialog--center .el-dialog__body {
    padding: 0;
  }
  .basic_info{
    color: #333;
    border: 1px solid #e4e4e4;
    padding-bottom: 0;
    padding-top: 20px;
    margin: 10px 0;

  }
  /* .dialog_form{
    background: #fff;
    padding:10px;
  } */

</style>



// WEBPACK FOOTER //
// src/components/parking-rental-details.vue